import { BusinessGetResponseType } from "@sellar-io/api-v2/types";
import { httpRequest, HttpResponse } from "~/utils/httpClient";
import { ExtendedFirebaseUser } from "../../useFirebaseUser.shared";

export type ApiOrderParams = [[string, "asc" | "desc"]];

export type ApiListParams = {
  scope?: string;
  where?: {
    [key: string]: string | number | boolean | [] | object | null | undefined;
  };
  search?: string;
  order?: ApiOrderParams;
  offset?: number;
  limit?: number;
  //for the order endpoint, need to think of something better for v2
  updatedAt?: Date;
};

export type SellarApiRequestType = {
  path: string;
  user?: ExtendedFirebaseUser | undefined;
  business: BusinessGetResponseType | null;
  method: "get" | "delete" | "post" | "put";
  params?: ApiListParams;
  data?: object;
};

export const sellarApiRequest = async <Response>({
  user,
  business,
  method,
  path,
  params = {},
  data,
}: SellarApiRequestType): Promise<HttpResponse<{ data: Response }>> => {
  let token: string | undefined;
  if (user) {
    token = await user.firebaseUser.getIdToken();
  }
  return httpRequest<{ data: Response }>({
    method,
    params,
    data,
    url: `${import.meta.env.VITE_API_V1_URL}/${path}`,
    headers: {
      ...(token && { authorization: `Bearer ${token}` }),
      ...(token &&
        business &&
        business.Retailer && { RetailerId: business.Retailer.id.toString() }),
      ...(token &&
        business &&
        business.Supplier && { SupplierId: business.Supplier.id.toString() }),
    },
  });
};
